const PostUpdateReason = {
  Create: 'create',
  Like: 'like',
  Donate: 'donate',
  PledgeDonateInKind: 'donateInKindPledge',
  Comment: 'comment',
  Share: 'share',
  Volunteer: 'volunteer',
};

export default PostUpdateReason;